import { VendorApplicationScreen } from "@/features/vendor/dashboard";

export default VendorApplicationScreen;
